import { TemplateCategory } from "@teaming/common-enums";

export default {
	customTemplateNameExists: "A template with that name already exists.",
	customTemplateNameRequired: "Custom template name is required.",
	defaultNoteTitle: "Note - {date}",
	deleteCustomTemplateError: "Failed to delete custom template: {message}",
	deleteCustomTemplateSuccess: "Template deleted.",
	fetchCustomTemplatesError: "Failed to fetch custom templates: {message}",
	saveCustomTemplateError: "Failed to save custom template: {message}",
	syncStreamError: "Failed to synchronize note stream: {message}",
	todayLabel: "Today, {date}",
	unexpectedError: "Unexpected error: {message}",
	attentionNeededWarning: "Some items need your attention.",
	deleteNoteSuccess: "Note deleted.",
	templateSavedSuccess: "Template saved.",
	oneTimeMeetingSavedSuccess: "One-time meeting saved.",
	recurrenceSavedSuccess: "Recurrence saved.",
	saveOneTimeMeetingError: "Failed to save one-time meeting: {message}",
	saveRecurrenceError: "Failed to save recurrence: {message}",

	abortTranscriptionSuccess: "Opre Assistant successfully removed.",
	abortTranscriptionError: "Failed to remove Opre Assistant: {message}",

	teamingTemplatesGroupLabel: "Opre Templates",
	customTemplatesGroupLabel: "Custom Templates",

	oneOnOneCategoryName: "{categoryName} 1:1",
	thisSpaceCategoryName: "{categoryName} (this space)",

	uploadStarted: "Uploading file, please wait",
	uploadFinished: "Upload finished",
	uploadError: "Error uploading: {message}",

	saveSettingsError: "Error saving settings: {message}",

	viewTranscriptionError: "Error finding transcription: {message}",
	rateTranscriptionError: "Error rating transcription: {message}",

	botAttemptMessage: "Meeting Assistant is trying to join your meeting.",
	botQueueMessage: "Meeting Assistant will retry in {seconds} seconds.",
	botErrorMessage: "Meeting Assistant was unable to join your meeting.",

	[ `templateCategory${ TemplateCategory.TEAM_TEMPLATES }label` ]: "Teams",
	[ `templateCategory${ TemplateCategory.ONE_ON_ONE_TEMPLATES }label` ]: "One-on-ones",
	[ `templateCategory${ TemplateCategory.MY_TEMPLATES }label` ]: "My Templates",

	[ `templateCategory${ TemplateCategory.TEAM_TEMPLATES }description` ]: "Opre’s curated starter pack of agenda templates for your team conversations.",
	[ `templateCategory${ TemplateCategory.ONE_ON_ONE_TEMPLATES }description` ]: "Opre’s curated starter pack of agenda templates for your 1:1 conversations.",
	[ `templateCategory${ TemplateCategory.MY_TEMPLATES }description` ]: "Your personal, private collection of agenda templates.",

	[ `templateCategory${ TemplateCategory.TEAM_TEMPLATES }placeholder` ]: "There are no custom templates associated with this team.",
	[ `templateCategory${ TemplateCategory.ONE_ON_ONE_TEMPLATES }placeholder` ]: "There are no custom templates associated with this one-on-one.",
	[ `templateCategory${ TemplateCategory.MY_TEMPLATES }placeholder` ]: "You have no saved custom templates. To save a custom template, create a note with some topics, and select 'Save as template' from that note's menu.",

	deleteRecurrenceSuccess: "Recurrence deleted.",
	deleteRecurrenceError: "Failed to delete recurrence: {message}",
};
